export enum TooltipSeverity {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
  INFORMATIVE = 'informative',
}
